define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext", "../../models/DnsZoneModel", "./dnsActions"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext, DnsZoneModel, DnsActions) {
    "use strict";
    var DnsDetails = /** @class */ (function () {
        function DnsDetails() {
            this.editModel = ko.observable(new DnsZoneModel());
            this.filterByAny = ko.observable("");
            this.nextRecord = ko.observableArray();
            this.currentPage = ko.observable(1);
            this.canExport = UserContext.hasAccess("Admin,Dns.Export");
            this.dnsActions = new DnsActions();
        }
        DnsDetails.prototype.init = function (id, provider) {
            var self = this;
            self.id = id;
            self.provider = provider;
            self.dnsActions.saveDnsZoneRecordCallback = function () {
                self.refreshDetails();
            };
            self.dnsActions.removeDnsZoneRecordCallback = function () {
                self.refreshDetails();
            };
            var getModelCall = self.getDetailsModel();
            // Get lookup data:
            var getLookupData = tools.ajaxGet({
                url: "/Dns/GetDnsDetailsLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.dnsLookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
            $.when(getLookupData, getModelCall).done(function (lookupData, data) {
                self.initGrid(self.dnsLookupLists.GridStructures.DnsRecordStructure);
                ko.applyBindings(self, document.getElementById("ko-main-content"));
                self.initLogs();
                $("#contextLoader").hide();
                $("#mainContext").show();
                if (provider === "Aws") {
                    setInterval(function () {
                        self.updateAwsChangeStatuses();
                    }, 30000);
                }
            });
        };
        DnsDetails.prototype.initGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "160px",
                template: function (dataItem) {
                    var html = "";
                    if (UserContext.hasAccess("Admin,Dns.Edit")) {
                        if (self.provider == "DynDns" && (dataItem.Type == "CNAME" || dataItem.Type == "A" || dataItem.Type == "AAAA")) {
                            html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i>Edit</a>';
                        }
                        if (self.provider == "Aws") {
                            html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i>Edit</a>';
                        }
                    }
                    if (UserContext.hasAccess("Admin,Dns.Delete")) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i>Delete</button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.nextRecord.push("");
            self.dnsRecordsTable = new KendoUtils.KendoUtils();
            var dataSource = {};
            var pageable = {};
            if (self.provider == "Aws") {
                dataSource = {
                    transport: {
                        read: {
                            url: "/Dns/GetDnsZoneRecords",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.id = self.id;
                                data.provider = self.provider;
                                data.total = self.editModel().RecordSetCount();
                                var grid = self.dnsRecordsTable.getGridData();
                                var currentPage = grid.dataSource.page();
                                if (currentPage > self.nextRecord().length) {
                                    grid.dataSource.page(self.nextRecord().length);
                                    data.nextRecord = self.nextRecord()[self.nextRecord().length - 1];
                                }
                                else {
                                    data.nextRecord = self.nextRecord()[currentPage - 1];
                                }
                                self.currentPage(currentPage);
                                log.log(grid.dataSource.page());
                                log.log(self.nextRecord());
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) {
                            var grid = self.dnsRecordsTable.getGridData();
                            var currentPage = grid.dataSource.page();
                            if (currentPage >= self.nextRecord().length) {
                                self.nextRecord.push(response.NextRecord);
                            }
                            log.log(grid.dataSource.page());
                            log.log(self.nextRecord());
                            return response.Data;
                        },
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: false
                };
                pageable = {
                    refresh: false,
                    pageSize: 100,
                    pageSizes: false,
                    numeric: false
                };
            }
            if (self.provider == "DynDns") {
                dataSource = {
                    transport: {
                        read: {
                            url: "/Dns/GetDnsZoneRecords",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.id = self.id;
                                data.provider = self.provider;
                                data.total = 0;
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) {
                            return response.Data;
                        }
                    }
                };
                pageable = {
                    pageSize: 10,
                };
            }
            var gridOptions = {
                dataSourceOptions: dataSource,
                gridOptions: {
                    toolbar: kendo.template($("#dns-toolbar-template").html()),
                    columns: columns,
                    pageable: pageable,
                    dataBound: function () {
                        //log.log('dataBound');
                    }
                    //resizable: true
                },
                enableExport: {
                    entityName: "DnsZoneRecord",
                    title: "Hosted Zone Records",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true,
                },
                gridId: "divDnsZoneRecordsTable",
                showPagerOnTop: true
            };
            self.dnsRecordsTable.initGrid(gridOptions);
            $("#divDnsZoneRecordsTable tbody").on("click", ".btn-edit", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.dnsActions.editDnsRecord(self.editModel().Provider(), self.editModel().Id(), dataItem.Id, dataItem.Name, dataItem.Type);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.dnsActions.removeDnsRecordConfirm(self.editModel().Provider(), self.editModel().Id(), dataItem.Id, dataItem.Name, dataItem.Type);
                event.preventDefault();
            });
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.dnsRecordsTable.getGridData().dataSource.page(1);
            });
        };
        DnsDetails.prototype.getDetailsModel = function () {
            var self = this;
            tools.ajaxGet({
                url: "/Dns/GetDnsZoneById",
                data: { id: self.id, provider: self.provider },
                success: function (result) {
                    if (result.Success) {
                        self.editModel(new DnsZoneModel(result.Data));
                    }
                    else {
                        log.error(result.Error);
                    }
                }
            });
        };
        DnsDetails.prototype.refreshDetails = function () {
            var self = this;
            self.nextRecord = ko.observableArray();
            self.nextRecord.push("");
            self.getDetailsModel();
            self.dnsRecordsTable.getGridData().dataSource.page(1);
            setTimeout(function () {
                self.updateAwsChangeStatuses();
            }, 300);
        };
        DnsDetails.prototype.getAwsChangeStatuses = function () {
            var self = this;
            tools.ajaxGet({
                url: "/Dns/GetAwsPendingStatus",
                success: function (result) {
                    if (result.Success) {
                        var dataItems = self.dnsRecordsTable.getGridData().dataItems();
                        ko.utils.arrayForEach(dataItems, function (dataItem) {
                            dataItem.Status = "";
                        });
                        if (result.Data.length > 0) {
                            ko.utils.arrayForEach(result.Data, function (status) {
                                var listItem = ko.utils.arrayFirst(dataItems, function (item) {
                                    return item.Name === status.RecordName;
                                });
                                if (listItem) {
                                    listItem.Status = status.Status;
                                }
                            });
                        }
                        self.dnsRecordsTable.getGridData().refresh();
                    }
                    else {
                        log.error(result.Error);
                    }
                }
            });
        };
        DnsDetails.prototype.updateAwsChangeStatuses = function () {
            var self = this;
            tools.ajaxGet({
                url: "/Dns/UpdateAwsChangeStatus",
                success: function (result) {
                    if (result.Success) {
                        self.getAwsChangeStatuses();
                    }
                    else {
                        log.error(result.Error);
                    }
                }
            });
        };
        DnsDetails.prototype.addNewDnsZoneRecordSet = function () {
            var self = this;
            self.dnsActions.editDnsRecord(self.editModel().Provider(), self.editModel().Id(), null, null);
        };
        DnsDetails.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        DnsDetails.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.dnsRecordsTable.exportTo();
            }
        };
        DnsDetails.prototype.initLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("DnsZoneRecord");
                dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return DnsDetails;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Dns/Details")) {
            var id = urls_1.urls.getStringIdFromQueryString();
            var provider = urls_1.urls.getQueryString("provider");
            if (!id) {
                id = urls_1.urls.getStringIdFromUrl();
            }
            log.log("Initialize DNS Details id: " + id + " provider: " + provider);
            $(function () {
                (new DnsDetails()).init(id, provider);
            });
        }
    }, 0);
    return DnsDetails;
});
//# sourceMappingURL=dnsDetails.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/dns/dnsDetails.js
// module id = 239
// module chunks = 2